// Mock data for Captiva Photobooth

export const CONTACT_INFO = {
  phone: '0491187506',
  email: 'contact@captivabooth.com',
  whatsapp: '0491187506',
  location: 'Belgique',
  baseLocation: '7170 Manage',
  instagramHandle: 'captiva.photobooth'
};

export const DELIVERY_INFO = {
  title: 'Zone d\'intervention & livraison',
  description: 'Nous intervenons dans toute la Belgique.',
  freeDeliveryZone: '📍 Livraison et installation gratuites dans un rayon de 30 km autour de 7170 Manage.',
  deliveryRates: [
    { range: '31 à 60 km', price: 25 },
    { range: '61 à 100 km', price: 50 },
    { range: '101 à 150 km', price: 80 },
    { range: 'Au-delà de 150 km', price: 'sur devis' }
  ],
  note: 'Tous les frais sont clairement indiqués avant validation de votre réservation.'
};

export const PHOTOBOOTHS = [
  {
    id: 'classique',
    name: 'Photobooth Classique',
    slug: 'photobooth-classique',
    tagline: 'L\'essentiel pour tous vos événements',
    description: 'Notre photobooth compact Captiva est la solution parfaite pour capturer les meilleurs moments de votre événement. Avec son design blanc élégant et son écran tactile intuitif, il s\'intègre parfaitement dans n\'importe quel décor.',
    image: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/jmk4ai49_fa3d3fe6-0673-4e50-8715-f0c0b7a74fe4.jpeg',
    images: [
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/jmk4ai49_fa3d3fe6-0673-4e50-8715-f0c0b7a74fe4.jpeg',
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/8qpuvrza_2197e6ac-357a-4239-8b25-1782706d4e09.jpeg',
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/481ggyjx_0f40dafe-26dc-4dae-971d-bfcbb84f190f.jpeg'
    ],
    features: [
      'Design compact blanc élégant',
      'Écran tactile haute définition',
      'Appareil photo professionnel intégré',
      'Imprimante thermique instantanée',
      'Logo personnalisable à l\'écran',
      'Installation simple et rapide',
      'Idéal pour tous types d\'événements'
    ],
    idealFor: ['Mariages', 'Anniversaires', 'Soirées privées', 'Événements d\'entreprise'],
    startingPrice: 150,
    priceLabel: 'À partir de'
  },
  {
    id: 'miroir',
    name: 'Miroir Booth',
    slug: 'miroir-booth',
    tagline: 'L\'expérience interactive premium',
    description: 'Notre miroir photobooth interactif "The Miroir Box" offre une expérience unique et mémorable. Avec son grand écran tactile de 1m60, son éclairage LED personnalisable et son design élégant, il devient le centre d\'attraction de votre événement.',
    image: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/b651wk4r_2cb78679-5007-412f-9719-c48eb8f93482.jpeg',
    images: [
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/b651wk4r_2cb78679-5007-412f-9719-c48eb8f93482.jpeg',
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/5x42x5kj_4686c7f9-dd57-4a77-b5cf-7c9e8b2103b9.jpeg',
      'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/rfliy2o7_b7b7b21f-df3a-47e7-a1aa-d6bdd74659f7.jpeg'
    ],
    features: [
      'Miroir interactif de 1m60 de hauteur',
      'Éclairage LED personnalisable (multicolore)',
      'Interface tactile haute définition',
      'Impression immédiate des photos',
      'Tapis rouge VIP et cordons chromés inclus',
      'Design élégant et tendance',
      'Effet "WOW" garanti pour vos invités'
    ],
    idealFor: ['Mariages premium', 'Galas d\'entreprise', 'Lancements de produits', 'Soirées VIP'],
    startingPrice: 250,
    priceLabel: 'À partir de',
    premium: true
  }
];

export const PRICING_PLANS = [
  // Photobooth Classique
  {
    id: 'classique-eclat',
    name: 'Formule Éclat',
    subtitle: '(photos numériques uniquement)',
    price: 150,
    popular: false,
    boothType: 'classique',
    features: [
      'Location du photobooth',
      'Photos digitales illimitées',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['classique']
  },
  {
    id: 'classique-smile',
    name: 'Formule Smile',
    subtitle: '(200 bandelettes ou 100 photos classiques)',
    price: 250,
    popular: false,
    boothType: 'classique',
    features: [
      'Location du photobooth',
      '200 bandelettes ou 100 photos classiques',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['classique']
  },
  {
    id: 'classique-prestige',
    name: 'Formule Prestige',
    subtitle: '(400 bandelettes ou 200 photos classiques)',
    price: 300,
    popular: true,
    boothType: 'classique',
    features: [
      'Location du photobooth',
      '400 bandelettes ou 200 photos classiques',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['classique']
  },
  {
    id: 'classique-infinity',
    name: 'Formule Infinity',
    subtitle: '(Impressions illimitées)',
    price: 400,
    popular: false,
    boothType: 'classique',
    features: [
      'Location du photobooth',
      'Impressions illimitées',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['classique']
  },
  // Miroir Booth
  {
    id: 'miroir-eclat',
    name: 'Formule Éclat',
    subtitle: '(photos numériques uniquement)',
    price: 250,
    popular: false,
    boothType: 'miroir',
    premium: true,
    features: [
      'Location du photobooth',
      'Photos digitales illimitées',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['miroir']
  },
  {
    id: 'miroir-smile',
    name: 'Formule Smile',
    subtitle: '(200 bandelettes ou 100 photos classiques)',
    price: 350,
    popular: false,
    boothType: 'miroir',
    premium: true,
    features: [
      'Location du photobooth',
      '200 bandelettes ou 100 photos classiques',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['miroir']
  },
  {
    id: 'miroir-prestige',
    name: 'Formule Prestige',
    subtitle: '(400 bandelettes ou 200 photos classiques)',
    price: 400,
    popular: true,
    boothType: 'miroir',
    premium: true,
    features: [
      'Location du photobooth',
      '400 bandelettes ou 200 photos classiques',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['miroir']
  },
  {
    id: 'miroir-infinity',
    name: 'Formule Infinity',
    subtitle: '(Impressions illimitées)',
    price: 600,
    popular: false,
    boothType: 'miroir',
    premium: true,
    features: [
      'Location du photobooth',
      'Impressions illimitées',
      'Livraison et retour de la box',
      'Location 24 heures (une journée complète)',
      'Cadres personnalisables illimités',
      'Envoi illimité par e-mail',
      'Galerie web sécurisée',
      'Assurance incluse (sans caution)',
      'Support technique 7j/7 - 9h-23h'
    ],
    cta: 'Réserver un photobooth',
    availableFor: ['miroir']
  }
];

export const EXTRA_OPTIONS = [
  {
    id: 'accessories-box',
    name: 'Boîte d\'accessoires',
    price: 'Offert',
    description: 'Ajoutez du fun à vos photos !',
    details: 'Peu importe le type d\'événement, les accessoires sont essentiels pour créer une animation photobooth réussie et engageante. Notre kit d\'accessoires amusants égayera vos participants et leur permettra d\'arborer moustaches, lunettes originales ou sourires décalés, parfaits pour briser la glace et dynamiser l\'ambiance.',
    image: 'https://images.pexels.com/photos/7281909/pexels-photo-7281909.jpeg?w=600&h=400&fit=crop'
  },
  {
    id: 'custom-layout',
    name: 'Layout personnalisé',
    price: 'Offert',
    description: 'Votre événement, votre style !',
    details: 'Créez un cadre photo 100% personnalisé avec vos couleurs, logos, textes et graphismes. Parfait pour renforcer l\'identité de votre marque ou le thème de votre événement. Design unique garanti !',
    image: 'https://images.unsplash.com/photo-1494621622354-777dad9c18e4?w=600&h=400&fit=crop'
  },
  {
    id: 'custom-backdrop',
    name: 'Fond personnalisé',
    price: 'Sur devis',
    description: 'Un décor sur-mesure pour votre événement',
    details: 'Créez une ambiance unique avec un fond entièrement personnalisé selon vos envies : arches florales pour mariages, couleurs corporate, décor événementiel thématique... Nous concevons le backdrop parfait adapté à votre budget et vos attentes.',
    image: 'https://images.unsplash.com/photo-1763560836989-d3636e2f82d8?w=600&h=400&fit=crop'
  }
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: 'Choisissez votre photobooth',
    description: 'Sélectionnez le modèle qui correspond le mieux à votre événement : Classique pour l\'essentiel, Miroir pour l\'expérience premium.'
  },
  {
    step: 2,
    title: 'Réservez votre date',
    description: 'Remplissez notre formulaire simple ou contactez-nous directement. Nous confirmons votre réservation rapidement.'
  },
  {
    step: 3,
    title: 'Profitez de votre événement',
    description: 'Nous nous occupons de tout : installation, configuration et support. Vous n\'avez qu\'à profiter !'
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Sophie & Thomas',
    event: 'Mariage',
    rating: 5,
    comment: 'Le miroir booth a été la star de notre mariage ! Tous nos invités ont adoré l\'expérience interactive. Les photos sont magnifiques et le service était impeccable.',
    date: '2024-09',
    verified: true
  },
  {
    id: 2,
    name: 'Marie Dubois',
    event: 'Anniversaire 40 ans',
    rating: 5,
    comment: 'Captiva a rendu mon anniversaire inoubliable ! Le photobooth classique était parfait, facile à utiliser pour tous les âges. Les impressions instantanées ont fait fureur !',
    date: '2024-10',
    verified: true
  },
  {
    id: 3,
    name: 'Jean-Marc (Corporate Event Manager)',
    event: 'Événement d\'entreprise',
    rating: 5,
    comment: 'Service professionnel et de qualité. Le miroir booth a créé une ambiance festive lors de notre soirée corporate. Installation rapide, équipe réactive. Je recommande !',
    date: '2024-11',
    verified: true
  },
  {
    id: 4,
    name: 'Laura & Kevin',
    event: 'Mariage',
    rating: 5,
    comment: 'Un grand merci à l\'équipe Captiva ! Le photobooth a animé toute la soirée. La galerie en ligne est un super plus pour revivre ces moments.',
    date: '2024-08',
    verified: true
  },
  {
    id: 5,
    name: 'Olivier Fontaine',
    event: 'Soirée privée',
    rating: 5,
    comment: 'Excellent rapport qualité-prix. Le photobooth classique a parfaitement rempli son rôle. Mes invités sont repartis avec de superbes souvenirs.',
    date: '2024-09',
    verified: true
  },
  {
    id: 6,
    name: 'Émilie & Nicolas',
    event: 'Fiançailles',
    rating: 5,
    comment: 'Le miroir booth est juste magique ! L\'expérience interactive a surpris et ravi tous nos invités. Un souvenir mémorable de nos fiançailles.',
    date: '2024-11',
    verified: true
  }
];

export const GALLERY_IMAGES = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1727764894973-28e7283a600c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwcGhvdG9ib290aHxlbnwwfHx8fDE3NjU3NjA0OTF8MA&ixlib=rb-4.1.0&q=85',
    category: 'wedding',
    title: 'Mariage élégant'
  },
  {
    id: 3,
    url: 'https://images.pexels.com/photos/7867919/pexels-photo-7867919.jpeg',
    category: 'wedding',
    title: 'Célébration de mariage'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1727892349075-401c9df83995?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxwYXJ0eSUyMHBob3RvYm9vdGh8ZW58MHx8fHwxNzY1NzYwNDk2fDA&ixlib=rb-4.1.0&q=85',
    category: 'party',
    title: 'Groupe au photobooth'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1727892349154-ac042a8565c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxwYXJ0eSUyMHBob3RvYm9vdGh8ZW58MHx8fHwxNzY1NzYwNDk2fDA&ixlib=rb-4.1.0&q=85',
    category: 'party',
    title: 'Ambiance conviviale'
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/8531226/pexels-photo-8531226.jpeg',
    category: 'party',
    title: 'Fête entre amis'
  },
  {
    id: 7,
    url: 'https://images.unsplash.com/photo-1765615202063-035f075ab79b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmcmllbmRzJTIwbGF1Z2hpbmclMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3NjU3NjEyMjd8MA&ixlib=rb-4.1.0&q=85',
    category: 'celebration',
    title: 'Amies qui célèbrent'
  },
  {
    id: 8,
    url: 'https://images.unsplash.com/photo-1544563422-a46c75a351e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwbGF1Z2hpbmclMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3NjU3NjEyMjd8MA&ixlib=rb-4.1.0&q=85',
    category: 'celebration',
    title: 'Confettis et joie'
  },
  {
    id: 9,
    url: 'https://images.unsplash.com/photo-1595461240565-1f5779bc1d2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxmcmllbmRzJTIwbGF1Z2hpbmclMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3NjU3NjEyMjd8MA&ixlib=rb-4.1.0&q=85',
    category: 'celebration',
    title: 'Groupe en fête'
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/7ew9onhk_20ca97dd-533a-46d1-b442-2914871cc920.jpeg',
    category: 'setup',
    title: 'Photobooth Classique en action'
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/szcqfpe1_a58f441e-9a39-4fe0-80aa-cafe0e44b1de.jpeg',
    category: 'setup',
    title: 'Miroir Booth lors d\'un événement'
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/z0bymp1g_2cb78679-5007-412f-9719-c48eb8f93482.jpeg',
    category: 'wedding',
    title: 'Miroir Booth mariage élégant'
  },
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/o27tgbjl_4686c7f9-dd57-4a77-b5cf-7c9e8b2103b9.jpeg',
    category: 'setup',
    title: 'Configuration Miroir Booth'
  },
  {
    id: 14,
    url: 'https://customer-assets.emergentagent.com/job_instabooth-5/artifacts/nckf4al7_b7b7b21f-df3a-47e7-a1aa-d6bdd74659f7.jpeg',
    category: 'setup',
    title: 'Installation professionnelle'
  }
];

export const FAQ_DATA = [
  {
    question: 'Quelle est votre zone d\'intervention ?',
    answer: 'Nous intervenons dans toute la Belgique. Des frais de déplacement peuvent s\'appliquer selon la distance.'
  },
  {
    question: 'Combien de temps avant dois-je réserver ?',
    answer: 'Nous recommandons de réserver au moins 2-3 semaines à l\'avance, surtout pour les week-ends et la haute saison (mai à septembre). Cependant, contactez-nous même pour des demandes de dernière minute !'
  },
  {
    question: 'Puis-je personnaliser le cadre des photos ?',
    answer: 'Absolument ! Toutes nos formules Confort et Premium incluent la personnalisation du cadre photo avec votre logo, texte, date d\'événement, etc.'
  },
  {
    question: 'Comment récupérer les photos après l\'événement ?',
    answer: 'Toutes les photos sont automatiquement uploadées sur une galerie en ligne sécurisée accessible via un lien que nous vous envoyons. Vous pouvez télécharger, partager et conserver vos photos indéfiniment.'
  },
  {
    question: 'Avez-vous besoin d\'une prise électrique ?',
    answer: 'Oui, nos photobooths nécessitent une prise électrique standard 220V à proximité (câble de 10m fourni).'
  },
  {
    question: 'Que se passe-t-il en cas de problème technique ?',
    answer: 'Nous offrons un support technique à distance pour toutes nos formules. Pour la formule Premium, une assistance sur place est disponible pour garantir le bon déroulement de votre événement.'
  }
];
